import { useLayoutEffect } from 'react';
import { scrollSelectedIntoView } from '../utils/scrollToSelected';

/** When `ready` flips true (list DOM committed), centre the first selected row in listRef. */
export default function useScrollSelectedOnOpen(ready, listRef, selector) {
  useLayoutEffect(() => {
    if (ready) scrollSelectedIntoView(listRef.current, selector);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ready]);
}
